// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".buttons__left[data-v-33070c9c] {\n  z-index: 6;\n  position: absolute;\n  bottom: 50%;\n  left: 1%;\n}\n.buttons__chevron[data-v-33070c9c] {\n  margin-bottom: 0.6rem;\n}\n@media screen and (max-width: 64em) {\n.buttons__left[data-v-33070c9c] {\n    bottom: 9.5%;\n    left: 0.5%;\n}\n}", ""]);
// Exports
module.exports = exports;
